import { locationImageURL, locationURL } from '../common.urls';
import ImmutableModel from '../immutable.model';


/**
 * A location retrieved from the backend.
 */
class Location extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {Boolean} is_default Is this the default selection in case no other is made.
   * @param {String} name
   * @param {String} short_name
   * @param {String} email
   * @param {String} phone
   * @param {Address} address
   * @param {Number} location_area
   * @param {String} open_hours
   * @param {String} route_description
   * @param {String} parking_info
   * @param {String} payment_options
   * @param {Array.<Number>} services
   * @param {Array.<Number>} other_services
   * @param {String} general_info Longer description about a location
   * @param {String} place_id Google placeID for Maps links
   * @paran {String} url Url for Location on website
   * @param {Number} distance Distance from the user's location to this location
   * @param {Number} city
   */
  constructor(
    id,
    is_default,
    name,
    short_name,
    email,
    phone,
    address,
    location_area,
    open_hours,
    route_description,
    parking_info,
    payment_options,
    services,
    other_services,
    general_info,
    place_id,
    url,
    city,
    image,
    distance=null,
  ) {
    super();

    this.id = id;
    this.is_default = is_default;
    this.name = name;
    this.short_name = short_name;
    this.email = email;
    this.phone = phone;
    this.address = address;
    this.location_area = location_area;
    this.open_hours = open_hours;
    this.route_description = route_description;
    this.parking_info = parking_info;
    this.payment_options = payment_options;
    this.distance = distance;
    this.services = services;

    if (this.services != null && other_services != null) {
      // Main services must be removed from others to prevent possible duplicates.
      this.other_services = other_services.filter(id => !this.services.includes(id));
      this.all_services = this.services.concat(this.other_services);
    }
    else {
      this.other_services = other_services;
      this.all_services = this.other_services;
    }

    if (this.short_name === this.address.postal_area) {
      this.card_title = this.short_name;
    }
    else {
      this.card_title = `${this.address.postal_area}, ${this.short_name}`;
    }

    this.general_info = general_info;
    this.place_id = place_id;
    this.url = url || locationURL(this);
    this.city = city;
    this.image = image || locationImageURL(this, 'thumbnail');
  }

  copy() {
    return new Location(
      this.id,
      this.is_default,
      this.name,
      this.short_name,
      this.email,
      this.phone,
      this.address,
      this.location_area,
      this.open_hours,
      this.route_description,
      this.parking_info,
      this.payment_options,
      this.services,
      this.other_services,
      this.general_info,
      this.place_id,
      this.url,
      this.city,
      this.image,
      this.distance,
    );
  }

  getIds() {
    return [this.id];
  }

  isArea() {
    return false;
  }

  includes(ids) {
    return ids.includes(this.id);
  }

  get domId() {
    return `location-${this.id}`;
  }
}

export default Location;
